import { ArrowDown } from "lucide-react";

export default function Hero() {
  const scrollToReel = () => {
    const el = document.getElementById("reel");
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 24;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section
      data-testid="hero-section"
      className="relative h-screen min-h-[680px] w-full overflow-hidden letterbox"
    >
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1440404653325-ab127d49abc1?auto=format&fit=crop&w=2400&q=85"
          alt="35mm cinema projector with dual reels"
          className="w-full h-full object-cover scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/70 to-[#050505]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_0%,_rgba(0,0,0,0.7)_100%)]" />
      </div>

      <div className="absolute inset-0 flex items-center px-6 md:px-12 lg:px-24 z-20">
        <div className="max-w-5xl">
          <div className="fade-up delay-100 flex items-center gap-4 mb-8">
            <span className="h-px w-12 bg-[#D4AF37]" />
            <p className="font-accent text-[10px] text-zinc-400">
              Cinematographer · Director of Photography · Auckland, NZ
            </p>
          </div>

          <h1 className="fade-up delay-200 font-serif-display text-[clamp(3rem,9vw,9rem)] leading-[0.95] tracking-tighter text-white">
            Stories told <br />
            in <em className="text-[#D4AF37] italic font-light">light</em> &amp; shadow.
          </h1>

          <p className="fade-up delay-300 mt-10 max-w-xl text-base md:text-lg text-zinc-400 font-light leading-relaxed">
            Leigh Elford &mdash; a seasoned Director of Photography based in
            Auckland, New Zealand. Over a decade shooting shorts, music videos
            and television, with a story-first approach to composition, light
            and movement.
          </p>

          <div className="fade-up delay-400 mt-12 flex flex-wrap items-center gap-6">
            <button
              data-testid="hero-cta-reel"
              onClick={scrollToReel}
              className="group inline-flex items-center gap-4 bg-white text-black hover:bg-[#D4AF37] transition-colors px-8 py-4 font-accent text-[11px]"
            >
              <span>Watch the Reel</span>
              <span className="h-px w-6 bg-black group-hover:w-10 transition-all" />
            </button>
            <a
              data-testid="hero-cta-bts"
              href="#bts"
              className="font-accent text-[11px] text-zinc-300 hover:text-[#D4AF37] underline-offset-8 underline decoration-zinc-700 hover:decoration-[#D4AF37] py-4"
            >
              Or see what it looked like →
            </a>
          </div>
        </div>
      </div>

      {/* Floating reel marquee at bottom */}
      <div className="absolute bottom-24 md:bottom-28 left-0 right-0 z-20 overflow-hidden">
        <div className="marquee-track flex gap-12 whitespace-nowrap text-zinc-700">
          {[...Array(2)].map((_, i) => (
            <div key={i} className="flex gap-12 items-center">
              {["RED Komodo", "Alexa Mini LF", "Cooke S4i", "Kowa Anamorphic", "Sony FX3", "Arri Master Prime", "DJI Ronin 4D"].map((t) => (
                <span key={t} className="font-accent text-[10px] flex items-center gap-12">
                  {t} <span className="text-[#D4AF37]">◆</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-3 text-zinc-500">
        <span className="font-accent text-[9px]">Scroll</span>
        <ArrowDown size={14} strokeWidth={1} className="animate-bounce" />
      </div>
    </section>
  );
}
